/**
 * BITESHIELD Custom Theme JavaScript
 * Handles FAQ accordions, ticker, image switching
 */

document.addEventListener('DOMContentLoaded', function() {

  // ===== FAQ ACCORDION =====
  const faqItems = document.querySelectorAll('.bs-faq__question');
  faqItems.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = this.parentElement;
      const isActive = item.classList.contains('active');

      // Close all others in same FAQ section
      const parent = item.closest('.bs-faq__list');
      if (parent) {
        parent.querySelectorAll('.bs-faq__item.active').forEach(function(activeItem) {
          activeItem.classList.remove('active');
          activeItem.querySelector('.bs-faq__question').setAttribute('aria-expanded', 'false');
        });
      }

      // Toggle current
      if (!isActive) {
        item.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ===== TICKER PAUSE ON HOVER =====
  const tickers = document.querySelectorAll('.bs-ticker__track');
  tickers.forEach(function(track) {
    track.addEventListener('mouseenter', function() {
      this.style.animationPlayState = 'paused';
    });
    track.addEventListener('mouseleave', function() {
      this.style.animationPlayState = 'running';
    });
  });

  // ===== SMOOTH SCROLL FOR ANCHOR LINKS =====
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
